var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts pie_charts",class:{bgColorEcharts:!!_vm.dailyKData.length}},[_c('v-chart',{attrs:{"options":_vm.kOptions,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }